export default "__VITE_ASSET__7rgpgVBT__"